export function useAsyncDataError(error: Ref<Error | null>, page: string) {
  if (!error.value) return;

  throw createError({ fatal: true, data: { error, page } });
}
